import template from './template.html';

controller.$inject = ['adalAuthenticationService'];

export function controller(adalAuthenticationService) {
    const vm = this;

    vm.user = adalAuthenticationService.userInfo;
    vm.logout = adalAuthenticationService.logOut;
    vm.login = adalAuthenticationService.login;

}

config.$inject = ['$stateProvider'];

function config($stateProvider) {
    $stateProvider.state('accessdenied', {
        controller: controller,
        controllerAs: 'vm',
        parent: 'guest',
        template: template,
        url: 'accessdenied'
    });
}

export default config;



// WEBPACK FOOTER //
// ./src/js/components/guest/accessdenied/index.js